export default __webpack_public_path__ + "static/media/circle-loading.e2ea34cf.svg";